import React,{Component} from "react";
import axios from "axios";
import { CheckCircleIcon, XIcon } from '@heroicons/react/solid';
import Dashboard from "./Dashboard";
import Forgetpassword from "./Forgetpassword";
import { Navigate  } from 'react-router-dom';
import mainLogo from'../mglogo.png';

class Login extends Component{

   
    constructor(props) {
      super(props);
      this.state = {
        showmsg: false,
        redirect: false,
        email:'',
        password:'',
        success:'false',
        error_list:[],
      };
    }
    
    handleInput= (e) =>{

        this.setState({
            [e.target.name]: e.target.value
        });
    }


loginUser =async (e)=>{

        e.preventDefault();    
        const res= await axios.post('public/api/login',this.state); 
        
        if(res.data.success){
            localStorage.setItem('token',res.data.token);
            
            this.setState({ showmsg: true })
            
            setTimeout(function() { //Start the timer
              this.setState({ redirect: true }) //After 1 second, set render to true
                  }.bind(this), 1000)

          
          this.setState({error_list:res.data.data});

        }  else{
          this.setState({error_list:res.data});
          
          
        }
    }

render(){
  
  let token= localStorage.getItem('token');
  if(token != null){
   
    return <Navigate to={'/FilterBy/Dashboard'} />
  }
  
  if(this.state.redirect){
    return <Navigate to={'/FilterBy/Dashboard'} />
}

    return (

      
        <>
          {/*
            This example requires updating your template:
    
            ```
            <html class="h-full bg-gray-50">
            <body class="h-full">
            ```
          */}
          <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
             
              <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Sign in to your account</h2>
              
                <p className="mt-2 text-center text-sm text-gray-600">
                  Or{' '}
                  <a href={"./crm/Register"} className="font-medium text-indigo-600 hover:text-indigo-500">
                    Register your account
                  </a>
                </p>
            </div>
    
            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
              <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                <form onSubmit={this.loginUser} className="space-y-6">
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                      Email address
                    </label>
                    <div className="mt-1">
                      <input
                        id="email"
                        name="email"
                        type="email"
                        onChange={this.handleInput}
                        autoComplete="email"
                        value={this.state.email}
                        required
                        className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      />
                    </div>
                    <p className="mt-2 text-sm text-red-600" id="email-error">
                     {this.state.error_list.email}
                    </p>
                  </div>
    
                  <div>
                    <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                      Password
                    </label>
                    <div className="mt-1">
                      <input
                        id="password"
                        name="password"
                        type="password"
                        onChange={this.handleInput}
                        autoComplete="current-password"
                        value={this.state.password}
                        required
                        className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      />
                    </div>
                    <p className="mt-2 text-sm text-red-600" id="email-error">
                     {this.state.error_list.password}
                    </p>
                  </div>
    
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <input
                        id="remember-me"
                        name="remember-me"
                        type="checkbox"
                        className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                      />
                      <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900">
                        Remember me
                      </label>
                    </div>
    
                    <div className="text-sm">
                      <a href={"./Forgetpassword"} className="font-medium text-indigo-600 hover:text-indigo-500 cursorpoint">
                        
                     
                        Forgot your password?
                      
                      </a>
                    </div>
                  </div>
    
                  <div>
                    <button
                      type="submit"
                      className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      Sign in
                    </button>
                  </div>
                  <p className="mt-2 text-sm text-red-600" id="email-error">
                     {this.state.error_list.message? this.state.error_list.message:""}
                     {this.state.error_list.password? this.state.error_list.password:""}
                    </p>
                </form>
    
               
              </div>
            </div>
          </div>
        </>
      )
}

}

export default Login;


